



















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import SerialInfo from "../../store/entities/serialinfo"
import moment from "vue-moment";
@Component
export default class ViewLocation extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: '' }) sku: String;
  @Prop({ type: String, default: '' }) productName: String;
  @Prop({ type: Array, default: ()=>[] }) serialNoes: Array<string>;
  @Prop({ type: Number, default: 0 }) qty: Number;

  title: string = '';
  cancel() {
    this.$emit("input", false);
  }
  created() {}
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
        this.title = `${this.sku} - ${this.productName}`;
    }
  }
}
